// extracted by mini-css-extract-plugin
export default {"container":"DeleteAreaModal_container__qxx1r","buttons":"DeleteAreaModal_buttons__RMTMI","denyContainer":"DeleteAreaModal_denyContainer__Ifw8k","btn":"DeleteAreaModal_btn__CpxZL"};